// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.rate[data-v-c2aea558]{padding-left:15px}ul[data-v-c2aea558]{list-style:none;padding-left:0}[data-v-c2aea558] .modal-footer{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding-top:13px!important;padding-bottom:13px!important}[data-v-c2aea558] .reservation-preview .modal-dialog{min-width:550px;width:550px}", ""]);
// Exports
module.exports = exports;
